import client from "./client";

export interface TwoFactorSetupResponse {
  qrCodeDataUrl: string;
  secret: string;
  backupCodes: string[];
}

export const setupTwoFactor = async (): Promise<TwoFactorSetupResponse> => {
  return await client
    .post("/2fa/setup")
    .then(response => response.data.response);
};

export const verifyTwoFactorSetup = async (
  code: string
): Promise<{ message: string }> => {
  return await client
    .post("/2fa/verify-setup", { code })
    .then(response => response.data.response);
};
